/*
 * @Description: 路由
 * @Date: 2025-06-19 09:45:57
 */
export const route = [
  {
    path: '/main/tax-mgmt-industry',
    name: 'tax-mgmt-industry',
    meta: {
      title: '完税证明'
    },
    component: () => import('../views/tax-mgmt-industry.vue')
  },
  {
    path: '/main/tax-mgmt-supplier',
    name: 'tax-mgmt-supplier',
    meta: {
      title: '完税证明'
    },
    component: () => import('../views/tax-mgmt-supplier.vue')
  },
  {
    path: '/main/tax-mgmt-asp',
    name: 'tax-mgmt-asp',
    meta: {
      title: '完税证明'
    },
    component: () => import('../views/tax-mgmt-asp/index')
  }
];
